import { 
    ACTION_ATTACK, ACTION_MOVE, ACTION_REST,
    TERRAIN_PLAIN, TERRAIN_TREE, TERRAIN_ROCK, TERRAIN_WATER 
}  from '../game/constants.js'

export class Render {
    static all(state) {
        if(!state) return

        Render.intro(state.game)
        Render.settings(state.game)

        if(state && state.game && state.game.state) {
            Render.outro(state.game.state)

            if( state.game.state.log ) {
                Render.log(state.game.state)
            }

            if(state.game.state.map && state.game.state.map.board) {
                Render.board(state.game.state.map.board, state.game.state.map.actions)

                if(state.game.state.adversaries && state.game.state.partiers) {
                    // attacks coming before characters ensures that the attacks are visible in the cell
                    // they replace the character by pushing it below the bottom of the viewport
                    // which is something that could be improved eventually so the attacks are on top of the characters
                    Render.attacks(state.game.state.attacks)
                    Render.characters(state.game.state)

                    Render.initiative(state.game.state)
                    Render.detail(state.game.state.characterWithInitiative())
                }
            }
        }
    }


    static attacks(attacks) {
        if(attacks.length < 1) {
            return
        }

        attacks.forEach( (attack, index) => {
            const targetCell = document.getElementById(
                Render.cellId(attack.target.x, attack.target.y)
            )
        
            const overlay = document.createElement("div")
            overlay.classList.add('attack')

            overlay.style.backgroundImage = "var(--sprite-attack)"
            overlay.style.backgroundSize = "cover"
            overlay.style.zIndex = "1000"
            

            targetCell.appendChild(overlay)
        })
    }

    static board(board, actions) {
        // console.info('Render.js - rendering board', board)
        // console.info('Render.js - rendering board', board[0][10])

        const containerLeftTop = document.getElementById("container-left-top")

        // doing y on the outside to assemble 11 rows of 11 cells
        for (let y = 0; y < board[0].length; y++) {           
            const gridRowsTop = y + 2
            const gridRowsBottom = y + 3

            for (let x = 0; x < board.length; x++) {
                const gridColumnsLeft = x + 2
                const gridColumnsRight = x + 3

                const oldCell = document.getElementById(Render.cellId(x, y))
                if(oldCell) {
                    const isActionable = [...actions.attack, ...actions.move, ...actions.rest].find(action => {
                        return (x === action.position.x && y === action.position.y)
                    })

                    if(isActionable) {
                        oldCell.classList.remove('masked')
                    } else {
                        oldCell.classList.add('masked')
                    }

                    Render.clearChildren(oldCell)
                } else {
                    const cell = document.createElement("div")
                    cell.id = Render.cellId(x, y)

                    cell.style.gridTemplateColumns = `${gridColumnsLeft} / ${gridColumnsRight}`
                    cell.style.gridTemplateRows = `${gridRowsTop} / ${gridRowsBottom}`

                    cell.classList.add('terrain')
                    switch(board[y][x]) {
                        case TERRAIN_TREE:
                            cell.classList.add('terrain-tree')
                            break

                        case TERRAIN_ROCK:
                            cell.classList.add('terrain-rock')
                            break

                        case TERRAIN_WATER:
                            cell.classList.add('terrain-water')
                            break

                        case TERRAIN_PLAIN:
                            cell.classList.add('terrain-plain')
                            break
                    }

                    containerLeftTop.appendChild(cell)
                }
            }

        }
    }

    static cellId(x, y) {
        return `${(x + "").padStart(2, "0")}-${(y + "").padStart(2, "0")}`
    }

    static characters(state) {
        // console.info('Render.js - rendering characters', state)
        const characters = state.allCharacters()

        characters.forEach(character => {
            if(!character.isAlive()) return

            const containingCell = document.getElementById(
                Render.cellId(character.position.x, character.position.y)
            )

            const renderedCharacter = document.createElement('div')
            renderedCharacter.style.backgroundImage = `var(--${character.archetype.cssImageVariable})`
            renderedCharacter.style.backgroundRepeat = 'none'
            
            renderedCharacter.classList.add('character')

            if(character.isAdversary) {
                renderedCharacter.classList.add('adversary')
            } else {
                renderedCharacter.classList.add('partier')
            }

            if(character.number === state.characterWithInitiative().number) {
                renderedCharacter.classList.add('active')
            }

            containingCell.appendChild(renderedCharacter)
        })
    }

    static clearChildren(node) {
        if(!node) return
        while (node.lastElementChild) {
            node.removeChild(node.lastElementChild);
        }
    }

    static detail(character) {
        if(!character) return

        document.getElementById('content-pane-detail-character-name').innerText = character.name
        document.getElementById('content-pane-detail-character-archetype').innerText = character.archetype.label
        document.getElementById('content-pane-detail-character-position').innerText = `(${character.position.x},${character.position.y})`

        const health = document.getElementById('content-pane-detail-character-health')
        if(character.isAdversary) {
            health.innerText = character.obfuscatedHealth()
        } else {
            health.innerText = `(${character.health} / ${character.maxHealth})`
        }
    }

    static initiative(state) {
        const contentPaneInitiativeTable = document.getElementById('content-pane-initiative-table')
        Render.clearChildren(contentPaneInitiativeTable)

        const initiative = state.initiative
        initiative.order.forEach( initChar => {
            const character = state.characterWithNumber(initChar.number)
            const nameCell = document.createElement('td')
            nameCell.innerText = character.name

            const conditionCell = document.createElement('td')
            conditionCell.innerText = character.obfuscatedHealth()

            const row = document.createElement('tr')
            row.appendChild(nameCell)
            row.appendChild(conditionCell)
            if(character.isAdversary) {
                row.classList.add('adversary')
            } else {
                row.classList.add('partier')
            }

            if(character.number === state.characterWithInitiative().number) {
                row.classList.add('active')
            }

            contentPaneInitiativeTable.appendChild(row)
        })
    }



    static intro(game) {
        // console.info('Render.js - rendering intro', game)
        const contentPanelIntro = document.getElementById('content-pane-intro')
        
        if(game === null) {
            if(contentPanelIntro.style.display === "block") return 

            contentPanelIntro.style.display = "block"    
        } else {
            if(contentPanelIntro.style.display === "hidden") return 

            contentPanelIntro.style.display = "none"    
        }
    }

    static log(state) {
        // console.info('Render.js - rendering log')

        const contentPaneLogHistoryItems = document.getElementById('content-pane-log-history-items')
        Render.clearChildren(contentPaneLogHistoryItems)
        
        state.log.forEach( entry => {
            const item = document.createElement('div')
            item.innerText = entry

            contentPaneLogHistoryItems.appendChild(item)
        })

        // scroll to the bottom of the container so the new item is always visible at the bottom
        contentPaneLogHistoryItems.scrollTop = contentPaneLogHistoryItems.scrollHeight;
        const input = document.getElementById('content-pane-log-command-line-input')

        // very clunky way to satisfy the need for the little animation here
        // duplicates logic in game
        // maybe move it to Utilities where they can share it? 
        const characterInOrder = state.initiative.order[state.initiative.indexWithInitiative]
        const characterWithInitiative = state.adversaries.concat(state.partiers).find(character => 
            character.number === characterInOrder.number
        )

        input.classList.remove('spinning')
        input.classList.remove('blinking')

        switch(state.action) {
            case ACTION_ATTACK:
                input.innerText = 'ATTACKING -'
                break
            case ACTION_MOVE:
                input.innerText = 'MOVING -'
                break
            default:
                if(characterWithInitiative.isAdversary) {
                    input.classList.add('spinning')
                    input.innerText = '|'
                } else {
                    input.classList.add('blinking')
                    input.innerText = '_'
                }
        }

    }

    static outro(state) {        
        const contentPanelOutro = document.getElementById('content-pane-outro')
         
        if(state && state.ended) {
            if(contentPanelOutro.style.display === "block") return 
            
            contentPanelOutro.style.display = "block"    
        } else {
            if(contentPanelOutro.style.display === "none") return 

            contentPanelOutro.style.display = "none"    
        }
    }

    static settings(game) {
        const contentPaneSettings = document.getElementById('content-pane-settings')
        const bottomRightTopFork = document.getElementById('bottom-right-top-fork')
        const bottomRightLeftFork = document.getElementById('bottom-right-left-fork')
        const bottomRighRightFork = document.getElementById('bottom-right-right-fork')
        
        if(game === null) {
            // console.info('Render.js - rendering settings')
            if(contentPaneSettings.style.display === "block") return 
            
            bottomRightTopFork.classList.remove('border-fork-down')
            bottomRightTopFork.classList.add('border-horizontal')

            bottomRightLeftFork.classList.remove('border-fork-right')
            bottomRightLeftFork.classList.add('border-vertical')
            
            bottomRighRightFork.classList.remove('border-fork-left')
            bottomRighRightFork.classList.add('border-vertical')
            
            contentPaneSettings.style.display = "block"    
        } else {
            if(contentPaneSettings.style.display === "hidden") return 

            bottomRighRightFork.classList.remove('border-vertical')
            bottomRighRightFork.classList.add('border-fork-left')
            
            bottomRightLeftFork.classList.remove('border-vertical')
            bottomRightLeftFork.classList.add('border-fork-right')
            
            bottomRightTopFork.classList.remove('border-horizontal')
            bottomRightTopFork.classList.add('border-fork-down')
            
            contentPaneSettings.style.display = "none"
        }
    }
}